import moment from 'moment-timezone';
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError } from './toast';
import { tokenExpired } from './auth';
import { isUUID, getSearchDateRange, isElasticLoad, isPlannedOrTodate } from '../helpers/common';
import {
    GET_MAP_EG_LIST, CLEAR_MAP_DATA, FILTER_MAP_EG_LIST, CLEAR_MAP_FILTERS, REFRESH_MAP_DATA,
    ADD_MAP_EG_KPI_BOX_REQUEST, ADD_MAP_EG_KPI_BOX, REMOVE_MAP_EG_KPI_BOX, SUBSCRIBE_MAP_EG_KPI,
    MAP_EG_CUSTOM_KPI, MAP_EG_REQUESTING, UNSUBSCRIBE_MAP_EG_KPI, GET_MAP_EG_SENSORS, MAP_LOADED,
    MAP_UNLOAD, MAP_POSITION, UPDATE_REPLAY_BOX, UPDATE_WORK_WINDOW, REPLAY_PARAMS, MAP_AUTO_ZOOM
} from '../constants/action-types';
import { dateToUTC } from '../helpers/moment-ex';
import { parseBaleKPI } from '../interceptors/analyze';
import { getPlannedDate } from './analyze';
import { VIEW_EG } from '../constants';

export const mapLoaded = () => ({ type: MAP_LOADED });

export const mapUnload = () => ({ type: MAP_UNLOAD });

export const mapPosition = payload => ({ type: MAP_POSITION, payload });

export const mapAutoZoom = isAutoZoom => ({ type: MAP_AUTO_ZOOM, payload: isAutoZoom });

export const mapEGRequesting = () => ({ type: MAP_EG_REQUESTING });

export const mapEGList = data => ({ type: GET_MAP_EG_LIST, payload: data });

export const filterMapEgList = filters => ({ type: FILTER_MAP_EG_LIST, filters });

export const clearMapFilters = () => ({ type: CLEAR_MAP_FILTERS });

export const clearMapData = isRetainFilter => ({ type: CLEAR_MAP_DATA, isRetainFilter });

export const refreshMapData = () => ({ type: REFRESH_MAP_DATA });

export const addMapEGKPIBoxRequest = (params) => ({ type: ADD_MAP_EG_KPI_BOX_REQUEST, params });

export const addMapEGKPIBox = (params, payload) => ({ type: ADD_MAP_EG_KPI_BOX, params, payload });

export const removeMapEGKPIBox = egId => ({ type: REMOVE_MAP_EG_KPI_BOX, egId });

export const egMapCustomKPI = (payload, params) => ({ type: MAP_EG_CUSTOM_KPI, payload, params });

export const getMapEgSensors = (payload, params) => ({ type: GET_MAP_EG_SENSORS, payload, params });

export const subscribeMapEGKPI = params => ({ type: SUBSCRIBE_MAP_EG_KPI, params });

export const unsubscribeMapEgKPI = egId => ({ type: UNSUBSCRIBE_MAP_EG_KPI, egId });

export const updateReplayBox = payload => ({ type: UPDATE_REPLAY_BOX, payload });

export const updateWorkWindow = payload => ({ type: UPDATE_WORK_WINDOW, payload });

export const setReplayParams = payload => ({ type: REPLAY_PARAMS, payload });

export const getMapEgList = (params) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        phone_device: 2,
        crew: 1,
        operator: 1,
        vehicle_spec: isElasticLoad() ? 1 : 0,
        plan_type_id: params.selectedPlanType
    };

    dispatch(mapEGRequesting());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: `mapEGList` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(mapEGList());
            } else if (agentResult.data) {
                dispatch(getLatestGPS(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Map EG List: ', ex.message);
            dispatch(mapEGList());
            dispatch(toastError(ex.message));
        });
}

export const getLatestGPS = egList => dispatch => {
    if (egList.length === 0) return dispatch(mapEGList(egList));

    const egIds = egList.map(e => e.equipment_group_uuid);
    defaultAgent.post('/api/equipment/group/sensor/latest', { equipment_group_uuid: egIds.join(','), sensor: 'gps,q_connection' })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(mapEGList(egList));
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                egList.forEach(item => {
                    if (agentResult.data.hasOwnProperty(item.equipment_group_uuid)) {
                        const gps = agentResult.data[item.equipment_group_uuid].gps;
                        if (gps && gps.data && Object.keys(gps.data).length > 0)
                            item["_gps"] = gps.data;

                        const qConnection = agentResult.data[item.equipment_group_uuid].q_connection;
                        if (qConnection && qConnection.data && Object.keys(qConnection.data).length > 0) {
                            if (qConnection.data.hasOwnProperty("ts") && typeof qConnection.data.ts === "string") {
                                qConnection.data.ts = moment.utc(qConnection.data.ts).valueOf();
                            }
                            item["_qConnection"] = qConnection.data;
                        }
                    }
                });
                dispatch(mapEGList(egList));
            }
        }).catch(ex => {
            dispatch(mapEGList(egList));
            dispatch(toastError(ex.message));
        });
}

export const getMapEGKPI = data => dispatch => {
    if (data.kpiType === "truck") return dispatch(getMapTruckKPI(data));
    if (data.kpiType === "baler") return dispatch(getMapBalerKPI(data));
    return dispatch(getMapNonTruckKPI(data));
}

export const getMapNonTruckKPI = data => dispatch => {
    dispatch(addMapEGKPIBoxRequest(data));

    const addToList = payload => {
        const params = {
            crewId: data.crewId,
            egId: data.egId,
            deviceId: data.deviceId,
            isTruck: data.isTruck,
            kpiType: data.kpiType
        };
        dispatch(addMapEGKPIBox(params, payload));
        dispatch(getMapEGSensors(data.egId));
        dispatch(subscribeMapEGKPI(params));

        const paramsKPI = {
            egId: data.egId,
            range: data.range,
            fromDate: null,
            toDate: null
        };

        if (payload && isPlannedOrTodate(data.range)) {
            paramsKPI.fromDate = payload.start_date;
            paramsKPI.toDate = payload.end_date;
        } else if (data.fromDate && data.toDate) {
            paramsKPI.fromDate = data.fromDate;
            paramsKPI.toDate = data.toDate;
        }

        if (paramsKPI.fromDate && paramsKPI.toDate)
            dispatch(getMapEGCustomKPI(paramsKPI));
    }

    // Check the crew is null or empty
    if (!isUUID(data.crewId)) return addToList(null);

    const getSummary = cb => {
        const params = {
            farm_uuid: data.farmId,
            crew_uuid: data.crewId,
            equipment_group_uuid: data.egId,
            range_type: data.range
        };

        if (data.fromDate && data.toDate) {
            params.from_date = data.fromDate;
            params.to_date = data.toDate;
        }

        defaultAgent.get(`/api/equipment/group/v1/summary`, params).then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
                return;
            }
            return cb(agentResult.message ? null : agentResult.data);
        }).catch(() => cb(null));
    }

    return getSummary(addToList);
}

export const getMapTruckKPI = data => (dispatch, getState) => {
    dispatch(addMapEGKPIBoxRequest(data));

    const addToList = payload => {
        if (isElasticLoad()) {
            const egItem = getState().map.egList.find(e => e.egId === data.egId);
            if (egItem) payload = { ...payload, load_weight: egItem.vehicleSpec ? egItem.vehicleSpec.capacity : 0 };
        }
        const params = {
            crewId: data.crewId,
            egId: data.egId,
            deviceId: data.deviceId,
            isTruck: data.isTruck,
            kpiType: data.kpiType,
            automaticLoad: isElasticLoad()
        };
        dispatch(addMapEGKPIBox(params, payload));
        dispatch(getMapEGSensors(data.egId));
        dispatch(subscribeMapEGKPI(params));
    }

    // Check the crew is null or empty
    // if (!isUUID(data.crewId)) return addToList(null);

    const getManualLoad = cb => {
        const params = {
            farm_uuid: data.farmId,
            crew_uuid: data.crewId,
            equipment_group_uuid: data.egId,
            range_type: data.range
        };

        if (data.fromDate && data.toDate) {
            params.from_date = data.fromDate;
            params.to_date = data.toDate;
        }

        const requestId = `mapKPIManualLoad_${data.egId}`;
        const api = data && data.planTypeId && data.planTypeId === 2 ? '/api/seed/load' : '/api/equipment/group/load/v1';
        defaultAgent.get(api, params, { requestId })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                    return;
                }
                return cb(agentResult.message ? null : agentResult.data);
            }).catch(ex => {
                if (defaultAgent.isCancel(ex)) return console.log('Map KPI Manual Load: ', ex.message);
                return cb(null);
            });
    }

    const getAutomaticLoad = (extraParams, cb) => {
        const params = {
            farm_uuid: data.farmId,
            equipment_group_uuid: data.egId,
            start_date: data.fromDate,
            end_date: data.toDate,
            ...extraParams
        };
        if (!(params.start_date && params.end_date)) return;

        params.start_date = moment.utc(params.start_date).format();
        params.end_date = moment.utc(params.end_date).format();

        const requestId = `mapKPIAutomaticLoad_${data.egId}`;
        defaultAgent.get(`api/equipment/group/load/estimate/summary`, params, { requestId })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                    return;
                }
                return cb(agentResult.data && agentResult.data.data ? agentResult.data : null);
            }).catch(ex => {
                if (defaultAgent.isCancel(ex)) return console.log('Map KPI Automatic Load: ', ex.message);
                return cb(null);
            });
    }

    if (isElasticLoad()) {
        const parseLoad = (load) => {
            return load && load.data && load.data[data.egId] ? addToList(load.data[data.egId]) : addToList(null);
        };

        if (isPlannedOrTodate(data.range)) {
            return dispatch(getPlannedDate({ ...data, view: VIEW_EG }, payload => {
                if (!(payload && payload.start_date && payload.end_date)) return parseLoad(null);

                return getAutomaticLoad({
                    start_date: payload.start_date,
                    end_date: payload.end_date
                }, parseLoad);
            }));
        } else return getAutomaticLoad(null, parseLoad);
    } else return getManualLoad(addToList);
}

export const getMapBalerKPI = data => (dispatch, getState) => {
    dispatch(addMapEGKPIBoxRequest(data));

    const addToList = payload => {
        const params = {
            crewId: data.crewId,
            egId: data.egId,
            deviceId: data.deviceId,
            isTruck: data.isTruck,
            kpiType: data.kpiType
        };
        dispatch(addMapEGKPIBox(params, payload));
        dispatch(getMapEGSensors(data.egId));
        dispatch(subscribeMapEGKPI(params));
    };

    const getBaleSensor = ({ fromDate, toDate }) => {
        const timezone = getState().farm.currentFarm.timezone_identifier;
        fromDate = dateToUTC(fromDate, timezone).format();
        toDate = dateToUTC(toDate, timezone).format();

        defaultAgent.post(`/api/equipment/group/sensor/data`, {
            equipment_group_uuid: data.egId,
            sensor: "bale",
            start_date: fromDate,
            end_date: toDate
        }, { requestId: `MapKPIBalerSensor` }).then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
                return;
            }
            else if (agentResult.data) {
                const bale = parseBaleKPI(agentResult.data, data.egId);
                return addToList({ bales: bale.bales, avgBaleTime: bale.avg_bale_time });
            }
            return addToList();
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Map KPI bale sensor: `, ex.message);
            return addToList();
        });
    }

    if (!isPlannedOrTodate(data.range)) return getBaleSensor(data);
    if (!data.crewId) return addToList();

    return defaultAgent.get(`api/crew/plannedDate`, {
        farm_uuid: data.farmId,
        crew_uuid: data.crewId,
        range_type: data.range
    }, { requestId: `MapKPIBalerPlannedDate` }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        }
        else if (agentResult.data) {
            const date = agentResult.data;
            if (date.start_date && date.end_date)
                return getBaleSensor({
                    fromDate: date.start_date,
                    toDate: date.end_date
                });
        }
        return addToList();
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Planned date for map KPI bale: `, ex.message);
        return addToList();
    });
}

export const getMapEGCustomKPI = data => dispatch => {
    const params = {
        equipment_group_uuid: data.egId,
        start_date: moment.utc(data.fromDate).startOf('day').format(),
        end_date: moment.utc(data.toDate).endOf('day').format()
    };

    defaultAgent.post(`api/equipment/group/kpi/data`, params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message)
                dispatch(toastError(agentResult.message));
            else if (agentResult.data)
                dispatch(egMapCustomKPI(agentResult.data, { egId: data.egId, range: data.range }));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getMapEGSensors = egId => dispatch => {
    if (!egId) return;

    const params = {
        equipment_group_uuid: egId,
        sensor: 'gps,battery_level,q_connection,grain_moisture,grain_yield,pto,fuel_level',
    }

    defaultAgent.post('/api/equipment/group/sensor/latest', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                if (!(agentResult.data && agentResult.data.hasOwnProperty(egId))) return;

                const sensors = agentResult.data[egId];
                dispatch(getMapEgSensors({
                    battery: getSensorData(sensors, "battery_level"),
                    qConnection: getSensorData(sensors, "q_connection"),
                    grainMoisture: getSensorData(sensors, "grain_moisture"),
                    grainYield: getSensorData(sensors, "grain_yield"),
                    pto: getSensorData(sensors, "pto"),
                    fuelLevel: getSensorData(sensors, "fuel_level"),
                    gps: getSensorData(sensors, "gps"),
                }, { egId }));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getSensorData = (sensors, sensorName, isDeleteDevice = true) => {
    const sensorData = sensors[sensorName] && sensors[sensorName].data
        && Object.keys(sensors[sensorName].data).length > 0 ? sensors[sensorName].data : null;
    if (!sensorData) return sensorData;
    if (!isDeleteDevice) return sensorData;

    if (sensorData.device_id) delete sensorData.device_id;
    if (sensorData.device_uuid) delete sensorData.device_uuid;

    return sensorData;
}
